<template>
  <div class="vip-page">
    <div class="vip-header">
      <div class="back" @click="$router.back()">
        <i class="van-icon van-icon-arrow-left"></i>
      </div>
      <h1>{{ $t('vip_center') }}</h1>
    </div>
    
    <div class="vip-banner">
      <div class="vip-level-info">
        <div class="current-level">{{ $t('current_vip_level') }} <span class="level-num">VIP{{ userVipLevel }}</span></div>
        <div class="next-level-tip">{{ $t('next_level_tip') }}</div>
      </div>
    </div>
    
    <div class="vip-progress-section">
      <div class="progress-title">{{ $t('upgrade_progress') }}</div>
      <div class="vip-progress-bar">
        <div class="vip-progress-fill" :style="{ width: progressPercent + '%' }"></div>
      </div>
      <div class="progress-detail">
        <span>{{ $t('current_experience') }}: {{ currentExp }}</span>
        <span>{{ $t('next_level_exp_needed') }}: {{ nextLevelExp }}</span>
      </div>
    </div>
    
    <div class="vip-privileges">
      <div class="section-title">{{ $t('vip_privileges') }}</div>
      <div class="privilege-list">
        <div class="privilege-item" v-for="(privilege, index) in privilegeList" :key="index">
          <div class="privilege-icon">
            <img :src="privilege.icon" :alt="privilege.title">
          </div>
          <div class="privilege-info">
            <div class="privilege-title">{{ privilege.title }}</div>
            <div class="privilege-desc">{{ privilege.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="vip-levels">
      <div class="section-title">{{ $t('vip_levels') }}</div>
      <div class="level-list">
        <div class="level-item" v-for="level in vipLevels" :key="level.id" :class="{ active: currentVipLevel === level.id }">
          <div class="level-name">{{ level.name }}</div>
          <div class="level-required">{{ $t('required_recharge') }}: {{ level.recharge }}</div>
          <div class="level-privileges">{{ level.privileges }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vip',
  data() {
    return {
      userVipLevel: 1,
      currentExp: 0,
      nextLevelExp: 10000,
      progressPercent: 0,
      currentVipLevel: 1,
      privilegeList: [
        {
          icon: '/static/image/vip/icon1.png',
          title: this.$t('higher_rebate'),
          desc: this.$t('higher_rebate_desc')
        },
        {
          icon: '/static/image/vip/icon2.png',
          title: this.$t('exclusive_bonus'),
          desc: this.$t('exclusive_bonus_desc')
        },
        {
          icon: '/static/image/vip/icon3.png',
          title: this.$t('priority_withdrawal'),
          desc: this.$t('priority_withdrawal_desc')
        },
        {
          icon: '/static/image/vip/icon4.png',
          title: this.$t('dedicated_service'),
          desc: this.$t('dedicated_service_desc')
        }
      ],
      vipLevels: [
        { id: 1, name: 'VIP1', recharge: '0', privileges: this.$t('vip1_privileges') },
        { id: 2, name: 'VIP2', recharge: '500', privileges: this.$t('vip2_privileges') },
        { id: 3, name: 'VIP3', recharge: '2000', privileges: this.$t('vip3_privileges') },
        { id: 4, name: 'VIP4', recharge: '5000', privileges: this.$t('vip4_privileges') },
        { id: 5, name: 'VIP5', recharge: '10000', privileges: this.$t('vip5_privileges') }
      ]
    };
  },
  created() {
    this.getUserVipInfo();
  },
  methods: {
    getUserVipInfo() {
      let that = this;
      this.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length);
          that.userVipLevel = parseInt(vip) || 1;
          that.currentVipLevel = that.userVipLevel;
          
          // 计算经验和进度
          that.currentExp = userInfo.totalgame || 0;
          that.calculateNextLevelExp();
        }
      }).catch(err => {
        console.error('获取用户信息失败:', err);
      });
    },
    calculateNextLevelExp() {
      // 根据当前VIP等级计算下一级所需经验
      const expNeeds = {
        1: 10000,
        2: 50000,
        3: 100000,
        4: 500000,
        5: 1000000
      };
      this.nextLevelExp = expNeeds[this.userVipLevel] || 1000000;
      this.progressPercent = Math.min(100, (this.currentExp / this.nextLevelExp) * 100);
    }
  }
};
</script>

<style scoped>
.vip-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
  padding-bottom: 30px;
}

.vip-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: linear-gradient(135deg, #3a7bd5, #00d2ff);
  display: flex;
  align-items: center;
  padding: 0 15px;
  z-index: 100;
}

.back {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.back i {
  font-size: 20px;
  color: #fff;
}

.vip-header h1 {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  margin: 0;
}

.vip-banner {
  margin-top: 60px;
  padding: 30px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 0 0 30px 30px;
}

.vip-level-info {
  text-align: center;
  color: #fff;
}

.current-level {
  font-size: 16px;
  margin-bottom: 10px;
}

.level-num {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10px;
}

.next-level-tip {
  font-size: 14px;
  opacity: 0.8;
}

.vip-progress-section {
  background: #fff;
  margin: 20px;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.progress-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.vip-progress-bar {
  width: 100%;
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

.vip-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.progress-detail {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  padding: 15px 20px;
  color: #333;
}

.privilege-list {
  background: #fff;
  margin: 0 20px;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.privilege-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.privilege-item:last-child {
  border-bottom: none;
}

.privilege-icon {
  width: 50px;
  height: 50px;
  margin-right: 15px;
}

.privilege-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.privilege-info {
  flex: 1;
}

.privilege-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.privilege-desc {
  font-size: 12px;
  color: #999;
}

.level-list {
  margin: 0 20px;
  display: flex;
  overflow-x: auto;
  gap: 15px;
  padding-bottom: 10px;
}

.level-item {
  min-width: 150px;
  background: #fff;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.level-item.active {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  transform: scale(1.05);
}

.level-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.level-item.active .level-name {
  color: #fff;
}

.level-required {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.level-item.active .level-required {
  color: rgba(255, 255, 255, 0.8);
}

.level-privileges {
  font-size: 11px;
  color: #999;
}

.level-item.active .level-privileges {
  color: rgba(255, 255, 255, 0.7);
}
</style>


// WEBPACK FOOTER //
// src/components/vip.vue